import { applyMiddleware, combineReducers, compose, createStore } from 'redux';
import { persistStore, persistReducer } from 'redux-persist';
import { thunk } from 'redux-thunk';

import storage from 'redux-persist/lib/storage';
import { AuthReducers } from './AuthReducers';
import { AppReducers } from './AppReducers';
import { ProductReducer } from './ProductReducers';
import { CartReducers } from './CartReducers';
import { BackListReducer } from './backListReducers';
import { adminReducers } from './adminReducers';

const middleware = applyMiddleware(thunk);

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const appReducer = combineReducers({
  auth: AuthReducers,
  app: AppReducers,
  products: ProductReducer,
  cart: CartReducers,
  admin: adminReducers,
  backlist: BackListReducer,
});

const rootReducer = (state, action) => {
  if (action.type === 'LOGOUT_ACTION') {
    storage.removeItem('persist:say_cheeze');

    const { products, ...rest } = state || {};
    return appReducer({ ...rest, products }, action);
  }

  return appReducer(state, action);
};

const persistConfig = {
  key: 'say_cheeze',
  storage: storage,
  blacklist: ['backlist'],
};
const persistedReducer = persistReducer(persistConfig, rootReducer);

//const store = createStore(rootReducers);

export const store = createStore(persistedReducer, {}, composeEnhancers(middleware));

export const persistor = persistStore(store);
